import React, { PureComponent } from 'react';
import dynamic from 'next/dynamic';
import styled from 'styled-components';

import Carousel from 'components/Carousel/Carousel';
import SlidesContext from 'components/Slides/SlidesContext';

const ResponsiveImages = dynamic(import('components/ResponsiveImage/ResponsiveImages'), { ssr: false });

const Wrapper = styled.div`
  img {
    width: 100%;
    object-fit: cover;
  }
`;

class SlideImages extends PureComponent {
  render() {
    const { currentStep, updateSlide, slides } = this.context;

    return (
      <Wrapper>
        <Carousel
          currentStep={currentStep}
          onStepChanged={updatedStep => updateSlide(updatedStep)}
          cardWidth={100}
          showControls={false}
        >
          {slides.map(({ leftImage }) => (
            <ResponsiveImages
              loading="lazy"
              key={leftImage}
              fileName={leftImage}
              width={385}
              height={150}
            />
          ))}
        </Carousel>
      </Wrapper>
    );
  }
}

SlideImages.contextType = SlidesContext;

export default SlideImages;
